import React from 'react';
import clsx from 'clsx';

/** Тумблер «вкл/выкл» в стиле терминала (.sb-switch: свечение, пружинящий
 *  кружок). `label` — для скринридера: видимой подписи у него нет, она стоит
 *  рядом в строке. `id` — чтобы подпись-<label htmlFor> тоже переключала. */
export const Switch: React.FC<{
  on: boolean; disabled?: boolean; label: string; title?: string; id?: string;
  onChange: (on: boolean) => void;
}> = ({ on, disabled, label, title, id, onChange }) => (
  <button type="button" role="switch" id={id} aria-checked={on} aria-label={label} title={title}
    disabled={disabled} onClick={() => onChange(!on)}
    data-on={on && !disabled}
    className={clsx('sb-switch', disabled && 'cursor-not-allowed opacity-50')}>
    <span/>
  </button>
);

export default Switch;
